import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, of, tap } from 'rxjs';
import { AuthService } from 'src/app/shared/services/auth.service';
import { environment } from 'src/environments/environment.generated';
@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): Observable<boolean> {
    if (environment.mock) {
      return of(true);
    }
    
    return this.authService.isAuthenticated$.pipe(tap(isAuth => {
      if (!isAuth) {
        console.log(`authGuard says that is NOT authenticated`);
        this.router.navigate(['/login']);
      } else {
        console.log(`authGuard says that IT IS authenticated`);
      }
    }))
  }
}
